import React, { Component } from "react";

export class Navigation extends Component {
  render() {
    return (
      <nav className="navbar navbar-expand-md navbar-light fixed-top bg-light">
        <div className="container">
            <a className="navbar-brand page-scroll" href="#page-top">
              <img src="img/logoTransSalmon.png" className={"logo-top"} alt="logo"/>
              <span>myHrs</span>
            </a>

          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item active">
                <a className="nav-link" href="#features">Features <span className="sr-only">(current)</span></a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#hiw">How It Works</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#services">Users</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#testimonials">Testimonials</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#price">Pricing</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#contact">Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/navigation.jsx